const config = {
  apiUrl: 'https://staging-api.logirate.org/',
  callbackUrlBase: 'https://staging-api.logirate.org/',
};

export default config;
